import FormattedMessage from 'I18n/components/FormattedMessage';
import { HR } from 'foundations-components/transitional/components/HR';
import { H5 } from 'foundations-components/transitional/components/H5';
import { useCallback, useContext, useRef } from 'react';
import { ACTIONS, SCREENS } from '../../../constants/Tracking';
import { AssociationModalPropsContext } from '../../../contexts/associationModal/PropsContext';
import { AssociationModalContext } from '../../../contexts/associationModal/context';
import AssociationLineItems from './AssociationLineItems';
import AssociationProperty from './AssociationProperty';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssociationProperties() {
  const {
    crmObjectType,
    usageTracker,
    lineItemsFeatureUnavailableComponent
  } = useContext(AssociationModalPropsContext);
  const {
    associationProperties
  } = useContext(AssociationModalContext);
  const isUserInteractionTracked = useRef(false);

  // need to track only first select open
  // after in amplitude we compare number of select interactions
  // and new asscoiations (line items) to created CRM object
  const trackSelectOpen = useCallback(() => {
    if (!isUserInteractionTracked.current) {
      usageTracker.trackInteraction(Object.assign({
        screen: SCREENS.associations,
        type: crmObjectType
      }, ACTIONS.associations.clickAssociateSelectToNewCrmObject));
      isUserInteractionTracked.current = true;
    }
  }, [crmObjectType, usageTracker]);
  if (!associationProperties.length) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationsPanel.tabs.create.associationProperties.title",
        options: {
          crmObjectType
        }
      })
    }), associationProperties.map(property => {
      if (property.definition.toObjectType === 'LINE_ITEM' && !lineItemsFeatureUnavailableComponent) {
        return /*#__PURE__*/_jsx(AssociationLineItems, {
          property: property
        }, property.id);
      }
      if (property.definition.toObjectType === 'LINE_ITEM' && lineItemsFeatureUnavailableComponent) {
        return lineItemsFeatureUnavailableComponent;
      }
      return /*#__PURE__*/_jsx(AssociationProperty, {
        property: property,
        trackSelectOpen: trackSelectOpen
      }, property.id);
    })]
  });
}
export default AssociationProperties;